import { types } from "mobx-state-tree";
import { withSetPropAction } from "../_extension/with-set-props";
import { User } from "../_models/user-roles/user";
export const Authentication = types
  .model({
    isAuthenticated: false,
    profile: types.maybeNull(User),
    grantedPermissions: types.optional(types.array(types.string), []),
    openChangePw: false,
  })
  .actions(withSetPropAction);
